import React from "react";

const BulbIcon = ({ color = "#0699A3" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M17.0001 21.75C17.0001 21.9489 16.9211 22.1396 16.7805 22.2803C16.6398 22.4209 16.449 22.5 16.2501 22.5H8.75012C8.55121 22.5 8.36044 22.4209 8.21979 22.2803C8.07914 22.1396 8.00012 21.9489 8.00012 21.75C8.00012 21.551 8.07914 21.3603 8.21979 21.2196C8.36044 21.079 8.55121 21 8.75012 21H16.2501C16.449 21 16.6398 21.079 16.7805 21.2196C16.9211 21.3603 17.0001 21.551 17.0001 21.75ZM20.7501 9.74995C20.7534 11.0002 20.4709 12.2347 19.9243 13.3592C19.3778 14.4837 18.5815 15.4685 17.5964 16.2384C17.4122 16.3796 17.2627 16.561 17.1593 16.7688C17.056 16.9767 17.0015 17.2054 17.0001 17.4375V18C17.0001 18.3978 16.8421 18.7793 16.5608 19.0606C16.2795 19.3419 15.8979 19.5 15.5001 19.5H9.50012C9.1023 19.5 8.72077 19.3419 8.43946 19.0606C8.15816 18.7793 8.00012 18.3978 8.00012 18V17.4375C7.99997 17.2081 7.94724 16.9819 7.84599 16.7762C7.74474 16.5704 7.59766 16.3906 7.41606 16.2506C6.43337 15.4852 5.63767 14.5064 5.08916 13.3881C4.54066 12.2698 4.25374 11.0414 4.25012 9.79589C4.22575 5.32777 7.837 1.60683 12.3014 1.49995C13.4014 1.47345 14.4956 1.66725 15.5196 2.06997C16.5436 2.47269 17.4767 3.07617 18.2639 3.84491C19.0512 4.61365 19.6767 5.53211 20.1037 6.54622C20.5306 7.56034 20.7504 8.64962 20.7501 9.74995ZM16.0307 9.96933C15.9611 9.8996 15.8784 9.84428 15.7873 9.80653C15.6963 9.76879 15.5987 9.74936 15.5001 9.74936C15.4016 9.74936 15.304 9.76879 15.2129 9.80653C15.1219 9.84428 15.0392 9.8996 14.9695 9.96933L12.5001 12.4396L10.0307 9.96933C9.89002 9.8286 9.69915 9.74954 9.50012 9.74954C9.3011 9.74954 9.11023 9.8286 8.9695 9.96933C8.82877 10.1101 8.74971 10.3009 8.74971 10.5C8.74971 10.699 8.82877 10.8898 8.9695 11.0306L11.7501 13.8103V17.25C11.7501 17.4489 11.8291 17.6396 11.9698 17.7803C12.1104 17.9209 12.3012 18 12.5001 18C12.699 18 12.8898 17.9209 13.0305 17.7803C13.1711 17.6396 13.2501 17.4489 13.2501 17.25V13.8103L16.0307 11.0306C16.1005 10.9609 16.1558 10.8782 16.1935 10.7872C16.2313 10.6961 16.2507 10.5985 16.2507 10.5C16.2507 10.4014 16.2313 10.3038 16.1935 10.2127C16.1558 10.1217 16.1005 10.039 16.0307 9.96933Z"
        fill={color}
      />
    </svg>
  );
};
export const EnhancedBulb = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24"
        cy="24"
        r="23"
        fill="none"
        stroke="#7C5C26"
        stroke-width="2"
      />

      <path
        d="M24 14C19.8579 14 16.5 17.3579 16.5 21.5C16.5 24.0488 17.8471 26.2896 19.916 27.5377C20.5827 27.9307 21 28.6452 21 29.4341V31C21 31.5523 21.4477 32 22 32H26C26.5523 32 27 31.5523 27 31V29.4341C27 28.6452 27.4173 27.9307 28.084 27.5377C30.1529 26.2896 31.5 24.0488 31.5 21.5C31.5 17.3579 28.1421 14 24 14Z"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M22 34H26"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M22 37H26"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
      />

      <line
        x1="24"
        y1="7"
        x2="24"
        y2="4"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="34.5"
        y1="10.5"
        x2="36.5"
        y2="8.5"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="13.5"
        y1="10.5"
        x2="11.5"
        y2="8.5"
        stroke="#7C5C26"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export default BulbIcon;
